// Copyright 2019 Esri
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.​

/**
 * Combine your Sagas into one output
 */

import { all, fork } from 'redux-saga/effects';

import * as authSagas from './_auth';
import * as configSagas from './_config';
import * as usersSagas from './_users';
import * as beneficiariosSagas from './_benef';
import * as covidSagas from './_covid';
import * as cumpliSagas from './_cumpli';
import * as notasSagas from './_nota';
import * as vestuarioSagas from './_vestuario';
import * as terapiaSagas from './_terapia';
import * as auxilioSagas from './_auxilio';
import * as prestamoSagas from './_prestamo';

export default function* rootSaga() {
  yield all([
    ...Object.values(authSagas),
    ...Object.values(configSagas),
    ...Object.values(usersSagas),
    ...Object.values(beneficiariosSagas),
    ...Object.values(covidSagas),
    ...Object.values(cumpliSagas),
    ...Object.values(notasSagas),
    ...Object.values(vestuarioSagas),
    ...Object.values(terapiaSagas),
    ...Object.values(auxilioSagas),
    ...Object.values(prestamoSagas),
    // more sagas from different files
  ].map(fork));
}
